import React from 'react';

function Award() {
  return (
    <section className="bd-award__area section-space">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6">
            <div className="section__title-wrapper text-center section__title-space">
              <div className="section__title-wrapper">
                <span className="section__subtitle">Experience</span>
              </div>
            </div>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="award__item-wrapper">
            {/* Job 1 */}
            <div
              className="row wow fadeInUp pad_20 border_bottom"
              data-wow-delay=".3s"
              data-wow-duration="1s"
            >
              <div className="col-lg-4">
                <div className="award__content text-center">
                  <h5 className="award__title">
                    <a href="#">Web Developer PHP | Laravel</a>
                  </h5>
                  <span className="award__meta text-center">
                    Avatar Global Services - Porur, Chennai <br /> 05/2023 -
                    12/2024
                  </span>
                </div>
              </div>
              <div className="col-lg-7">
                <p
                  className="award__text bd-img-reveal bd-img-reveal-item"
                  style={{ color: '#c5cacf' }}
                  data-img="assets/imgs/award/award-1.jpg"
                  data-fx="1"
                >
                  Worked on 10+ websites, including AvatarJobs Portal for staff
                  management, Hostia Hosur membership site, and Divaz
                  Consultancy e-commerce platform. Also developed
                  SmartHomeCinemas, featuring WhatsApp-integrated form
                  submissions.
                </p>
              </div>
              <div className="col-lg-1">
                <div className="award__btn">
                  <a className="circle-btn is-large" href="#">
                    <span className="icon__box">
                      <i className="fa-regular fa-arrow-right-long"></i>
                    </span>
                  </a>
                </div>
              </div>
            </div>

            {/* Job 2 */}
            <div
              className="row wow fadeInUp pad_20"
              data-wow-delay=".3s"
              data-wow-duration="1s"
            >
              <div className="col-lg-4">
                <div className="award__content text-center">
                  <h5 className="award__title">
                    <a href="#">Web Developer PHP</a>
                  </h5>
                  <span className="award__meta text-center">
                    Goldmine Infotech Pvt.Ltd - T.Nagar, Chennai <br /> 01/2022
                    - 04/2023
                  </span>
                </div>
              </div>
              <div className="col-lg-7">
                <p
                  className="award__text bd-img-reveal bd-img-reveal-item"
                  style={{ color: '#c5cacf' }}
                  data-img="assets/imgs/award/award-1.jpg"
                  data-fx="1"
                >
                  A web development firm providing tech solutions. Worked on
                  15+ websites, including Shopify for Trusnax and Sindur
                  Textiles. Contributed to Glosil Scientific LLP
                  (front-end/back-end). Designed project images using Photoshop
                  and managed hosting on Hostinger.
                </p>
              </div>
              <div className="col-lg-1">
                <div className="award__btn">
                  <a className="circle-btn is-large" href="#">
                    <span className="icon__box">
                      <i className="fa-regular fa-arrow-right-long"></i>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Award;
